import React from 'react';
import { FormCol, FormRow, Label, Text, FormGroup, Size } from '@cmctechnology/phoenix-stockbroking-web-design';
import { useTranslation } from 'react-i18next';
import { IPassportDetails } from '../models/identification';
import { COUNTRIES_ALL } from '../constants/countryConstants';
import { ReviewEditButton } from '../Components/ReviewEditButton';

export interface IReviewIdentificationPassportProps {
  passport: IPassportDetails;
  onEdit: () => void;
}

export const ReviewIdentificationPassport: React.FC<IReviewIdentificationPassportProps> = ({ passport, onEdit }) => {
  const { t } = useTranslation();
  return (
    <FormGroup>
      <FormRow>
        <FormCol percentWidth={80}>
          <FormRow>
            <FormCol percentWidth={53}>
              <Label>{t('Type of ID')}</Label>
            </FormCol>
            <FormCol percentWidth={47}>
              <Text size={Size.Medium}>{t('Passport')}</Text>
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol percentWidth={53}>
              <Label>{t('Country of issue')}</Label>
            </FormCol>
            <FormCol percentWidth={47}>
              <Text size={Size.Medium}>{COUNTRIES_ALL[passport.countryOfIssue]?.(t)}</Text>
            </FormCol>
          </FormRow>
          <FormRow>
            <FormCol percentWidth={53}>
              <Label>{t('Number')}</Label>
            </FormCol>
            <FormCol percentWidth={47}>
              <Text size={Size.Medium}>{passport.passportNumber}</Text>
            </FormCol>
          </FormRow>
        </FormCol>
        <FormCol percentWidth={20}>
          <FormRow>
            <ReviewEditButton label={t('Edit')} onClick={onEdit} />
          </FormRow>
        </FormCol>
      </FormRow>
    </FormGroup>
  );
};
